import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const PlusIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stockholm-icons / Navigation / Plus">
        <rect id="Rectangle 185" x="4" y="11" width="16" height="2" rx="1" {...svgAttrs} />
        <rect
          id="Rectangle 185 Copy"
          x="13"
          y="4"
          width="16"
          height="2"
          rx="1"
          transform="rotate(90 13 4)"
          {...svgAttrs}
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
